var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgControlledPrescription(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 19,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cgh{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-45 -537)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cgh",
    width: 15,
    height: 19,
    rx: 2,
    transform: "translate(45 537)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M45 543h15v7H45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cgh",
    d: "M45 550h15v4a2 2 0 01-2 2H47a2 2 0 01-2-2v-4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlledPrescription);
export default __webpack_public_path__ + "static/media/controlled_prescription.dd9c18c5.svg";
export { ForwardRef as ReactComponent };